import React from 'react';

export default {
    'pages.HomePage': React.lazy(() => import('../ContentPage/ContentPage')), // The reason we use ContentPage here is because the HomePage is a ContentPage, only difference being that "Slides" block is available
    'pages.ContentPage': React.lazy(() => import('../ContentPage/ContentPage')),
    'pages.ContactPage': React.lazy(() => import('../ContactPage/ContactPage')),
} as {
    [key: string]: React.LazyExoticComponent<React.ComponentType<any>>;
};
